module.exports = __webpack_public_path__ + "static/media/CitrusStage1.5.8bf8bf13.PNG";